import clientConfig from "../clientConfig";

export const getMyAccountBaseUrl = () => clientConfig.get().MY_ACCOUNT_BASE_URL;
